import angular from 'angular'

import OneUpDesigner from 'emun.on-demand/shopping/shopping-one-up-designer'
import AddDesignToCart from 'emun.on-demand/shopping/shopping-add-design-to-cart'
import CloneDesignToCart from 'emun.on-demand/shopping/shopping-clone-design-to-cart'
import DesignerPortal from 'emun.on-demand/designer-portal'
import DesignerContainer from 'emun.on-demand/designer-container'
import DesignerCanvas from 'emun.on-demand/designer-canvas'
import DesignerToolbar from 'emun.on-demand/toolbars/designer-toolbar'
import DesignLayerField from 'emun.on-demand/layers/design-layer-field'
import DesignLayerEditor from 'emun.on-demand/layers/design-layer-editor'
import DesignLayerFontPicker from 'emun.on-demand/layers/design-layer-font-picker'
import FabricDesigner from 'emun.on-demand/fabric-designer'
import RegisterAdmin from 'emun.on-demand/admin/od-admin.register-modules'
import ProductTemplateManager from 'emun.on-demand/templates/od-product-template-manager'
import ProductTemplateManagerDependent from 'emun.on-demand/templates/od-product-template-manager-dependent'
import ProductTemplateEditor from 'emun.on-demand/templates/od-product-template-editor'
import ProductTemplateFieldset from 'emun.on-demand/templates/od-product-template-fieldset'
import ProductTemplateImages from 'emun.on-demand/templates/od-product-template-images'
import ProductTemplateDocuments from 'emun.on-demand/templates/od-product-template-documents'
import DesignAreaFieldset from 'emun.on-demand/templates/od-design-area-fieldset'
import DesignAreaOverlayFieldset from 'emun.on-demand/templates/od-design-area-overlay-fieldset'
import UploadMedia from 'emun.on-demand/media/upload-media'
import MediaBrowser from 'emun.on-demand/media/media-browser'
import MediaManager from 'emun.on-demand/media/od-media-manager'
import MediaManagerDependent from 'emun.on-demand/media/od-media-manager-dependent'
import MediaFieldset from 'emun.on-demand/media/od-media-fieldset'
//import DesignManager from 'emun.on-demand/designs/od-design-manager'
//import DesignManagerDependent from 'emun.on-demand/designs/od-design-manager-dependent'
//import DesignFieldset from 'emun.on-demand/designs/od-design-fieldset'
import webcolors from 'webcolors/_webcolors.app';
import webfonts from 'webfonts/_webfonts.app';
import ngFileUpload from 'ng-file-upload';

const dependencies = [
    'views',
    'emun.auth',
    'webcolors',
    'webfonts',
    'emun.cart',
    'emun.shopping',
    'ngFileUpload',
    'ui.router'];

function Routes($stateProvider, $urlRouterProvider, $locationProvider) {
}

let module = angular.module('emun.on-demand', dependencies)
    .component('designerPortal', DesignerPortal)
    .component('uploadMedia', UploadMedia)
    .component('odProductTemplateManager', ProductTemplateManager)
    .component('odProductTemplateManagerDependent', ProductTemplateManagerDependent)
    .component('odProductTemplateEditor', ProductTemplateEditor)
    .component('odProductTemplateFieldset', ProductTemplateFieldset)
    .component('odProductTemplateImages', ProductTemplateImages)
    .component('odProductTemplateDocuments', ProductTemplateDocuments)
    .component('mediaBrowser', MediaBrowser)
    .component('odMediaManager', MediaManager)
    .component('odMediaManagerDependent', MediaManagerDependent)
    .component('odMediaFieldset', MediaFieldset)
    .component('odDesignAreaFieldset', DesignAreaFieldset)
    .component('odDesignAreaOverlayFieldset', DesignAreaOverlayFieldset)
    .component('designerToolbar', DesignerToolbar)
    .component('designLayerEditor', DesignLayerEditor)
    .component('designLayerField', DesignLayerField)
    .component('designLayerFontPicker', DesignLayerFontPicker)
    .component('shoppingOneUpDesigner', OneUpDesigner)
    .component('shoppingAddDesignToCart', AddDesignToCart)
    .component('shoppingCloneDesignToCart', CloneDesignToCart)
    .directive('canvas', DesignerCanvas)
    .component('fabricDesigner', FabricDesigner)
    .config(Routes);
    // .run(($rootScope) => {
    //     $rootScope.$on('creatingCartItem', (e, args) => {
    //         const cartItem = args.cartItem;
    //         const product = cartItem.product;

    //         if (product.isOnDemand) {
    //             let option = {
    //                 fieldId: 'OnDemand',
    //                 valueId: {}
    //             };
    //             product.areas.forEach(a => option.valueId[a.euid] = {
    //                 id: a.design.id,
    //                 euid: a.design.euid,
    //                 label: a.design.label,
    //                 width: a.design.width,
    //                 height: a.design.height,
    //                 background: a.design.background,
    //                 url: a.design.url,
    //                 //images: a.design.images,
    //                 overlayIds: a.overlays.map(o => o.euid),
    //                 underlayIds: (a.underlays || []).map(o => o.euid)
    //             });
    //             option.valueId = JSON.stringify(option.valueId);
    //             cartItem.options.push(option);
    //         }
    //     });
    //     $rootScope.$on('cartSubmitting', (e, args) => {
    //         const cart = args.cart;
    //         const promises = args.promises;
    //     });
    // });

RegisterAdmin(module);

export default module.name;